import _ from "lodash";

const getUpdatedFields = (originalValues:any,newValues: any): object => {
    const updated = {}
    Object.keys(newValues).forEach(value => {
        if (!_.isEqual(newValues[value], originalValues[value]))
            updated[value] = newValues[value]
    })
    return updated
}

export default getUpdatedFields